import { render } from "./PartnerForm.vue?vue&type=template&id=2dbff359&scoped=true"
import script from "./PartnerForm.vue?vue&type=script&lang=js"
export * from "./PartnerForm.vue?vue&type=script&lang=js"

import "./PartnerForm.vue?vue&type=style&index=0&id=2dbff359&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbff359"]])

export default __exports__